import { render, staticRenderFns } from "./VacationsApprovedDayLegend.vue?vue&type=template&id=0b3cf2f8&"
import script from "./VacationsApprovedDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationsApprovedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3cf2f8')) {
      api.createRecord('0b3cf2f8', component.options)
    } else {
      api.reload('0b3cf2f8', component.options)
    }
    module.hot.accept("./VacationsApprovedDayLegend.vue?vue&type=template&id=0b3cf2f8&", function () {
      api.rerender('0b3cf2f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/VacationsApprovedDayLegend.vue"
export default component.exports